module.exports = __webpack_public_path__ + "img/blue.03b88532.svg";